import Switch from "@imminently/decisively-ui/Switch";
import { usePreferences } from "../PreferencesContext";
import type { FeatureSettings } from "@/config/features";

type DesignKey = keyof FeatureSettings["design"];

interface FeatureDef {
  key: DesignKey;
  label: string;
  description: string;
}

const FEATURES: FeatureDef[] = [
  {
    key: "compact",
    label: "Compact Design",
    description: "Enable the new compact design system for the platform",
  },
];

export const DesignPanel = () => {
  const { featureSettings, toggleFeature } = usePreferences();

  return (
    <div className="p-8 space-y-6 max-w-2xl">
      <div>
        <h2 className="text-2xl font-bold">Design Features</h2>
        <p className="text-muted-foreground mt-1">Visual design and layout options</p>
      </div>

      <div className="space-y-2">
        {FEATURES.map((feature) => (
          <div
            key={feature.key}
            className="flex items-start justify-between px-4 py-4 rounded-lg border bg-card gap-4"
          >
            <div className="flex-1 min-w-0">
              <label
                htmlFor={`design.${feature.key}`}
                className="block text-sm font-medium cursor-pointer mb-1"
              >
                {feature.label}
              </label>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </div>
            <Switch
              id={`design.${feature.key}`}
              checked={featureSettings.design[feature.key]}
              onCheckedChange={() => toggleFeature(`design.${feature.key}`)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
